import axios from 'axios';

import URLS from './urls';
import Utils from './mci-utils';

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.get['Accept'] = 'application/json';
axios.defaults.timeout = 1005000;

const currentUser = sessionStorage.user ? JSON.parse(sessionStorage.user) : '';

if (currentUser) {
  axios.defaults.headers.common['Authorization'] = `Token ${currentUser.token}`;
}

axios.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    // console.log(error);
    return Promise.reject(error.response);
  }
);

const { startOfWeek, today } = Utils.getTimeRanges();

const buildFormData = formObj => {
  const formData = new FormData();

  const keys = Object.keys(formObj);

  for (let i in keys) {
    let varname = keys[i];
    formData.append(varname, formObj[varname]);
  }

  return formData;
};

/**
 *
 * AUTH & REGISTRATION
 *
 */
export const registerUser = user => {
  return axios.post(URLS.register, user);
};

export const resetPassword = username => {
  return axios.post(URLS.resetPassword, { username });
};

export const changeUserPassword = user => {
  return axios.post(URLS.changeUserPassword, user);
};

export const getAdmins = company => {
  if (company === null) {
    return axios.get(URLS.insurerAdmins);
  }
  return axios.get(URLS.insurerAdmins + '?company=' + company);
};

export const getUsers = () => {
  return axios.get(URLS.allusers);
};

export const getFilteredUsers = filter => {
  return axios.get(URLS.allusers, {
    params: {
      ...filter
    }
  });
};

export const createUsers = () => {
  return axios.post(URLS.register);
};

export const editUserProfile = user => {
  const formData = buildFormData(user);

  return axios.patch(URLS.allusers + user.id + '/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

/**
 *
 * QUOTE DATA, GOODS & CURRENCIES
 *
 */
export const getConveyance = () => {
  return axios.get(URLS.conveyance);
};

export const getCurrencyList = () => {
  return axios.get(URLS.currency);
};

export const getCurrencyRates = () => {
  return axios.get(URLS.currency_rates);
};

export const getCurrencyRate = currency => {
  return axios.get(URLS.currencyRate + currency + '/');
};

export const getCountries = () => {
  return axios.get(URLS.countries);
};

export const getPorts = country => {
  return axios.get(URLS.port, {
    params: {
      country
    }
  });
};

export const getPortsVia = conveyance => {
  return axios.get(URLS.portsVia, {
    params: {
      conveyance
    }
  });
};

export const getDestinationTowns = () => {
  return axios.get(URLS.town);
};

export const getDestinationPorts = conveyance => {
  return axios.get(URLS.portsVia + '?conveyance=' + conveyance);
};

export const getVessels = () => {
  return axios.get(URLS.vessels);
};

export const getGoodsSections = () => {
  return axios.get(URLS.goodsSection);
};

export const getGoodCategories = () => {
  return axios.get(URLS.goodsCategory);
};

export const getGoods = category => {
  return axios.get(URLS.goods, {
    params: {
      category: category
    }
  });
};

/**
 *
 * GOODS/COMPARISON RATES
 *
 */

export const getPremiumRates = filter => {
  return axios.get(URLS.premiumRates, {
    params: {
      ...filter
    }
  });
};

export const editPremiumRates = ratesObj => {
  return axios.patch(URLS.premiumRagittes + ratesObj.id + '/', ratesObj);
};

export const addCustomPremiumRates = ratesObj => {
  return axios.post(URLS.customPremiumRates, ratesObj);
};

export const getGoodsRate = (section, category, conveyance, insurer) => {
  return axios.get(URLS.premiumRates, {
    params: {
      insurer: insurer,
      section: section,
      conveyance: conveyance,
      category: category
    }
  });
};

export const getComparisonGoodsRates = (
  containerized,
  category,
  conveyance
) => {
  return axios.get(URLS.comparisonRates, {
    params: {
      is_containerized: containerized,
      section: category,
      conveyance: conveyance
    }
  });
};

export const getComparisonOtherRates = () => {
  return axios.get(URLS.comparisonOtherRates);
};

export const getStampDuty = () => {
  return axios.get(URLS.stampDuty);
};

export const getOtherRates = filter => {
  return axios.get(URLS.otherRates, {
    params: {
      ...filter
    }
  });
};

export const requestSelcomPayment = quote => {
  return axios.get(URLS.requestSelcomPayment + quote);
};

export const addOtherRates = rates => {
  return axios.post(URLS.otherRates, rates);
};

export const updateOtherRates = rates => {
  return axios.put(URLS.otherRates + rates.id + '/', rates);
};

export const getCommissions = () => {
  return axios.get(URLS.commissions);
};

/**
 *
 * QUOTES & SUPPORTING DOCUMENTS
 *
 */
export const sendQuotationEmail = data => {
  return axios.post(URLS.emailQuote, data);
};

// export const getQoutes = () => {
//   return axios.get(URLS.quotes);
// };
export const getPageQoutes = page => {
  return axios.get(URLS.quotes, {
    params: {
      page
    }
  });
};
export const saveQuote = quote => {
  return axios.post(URLS.quotes, quote);
};
export const checkPaymentStatus = quote => {
  return axios.get(URLS.quotes + quote + '/');
};
export const updateQuote = policy => {
  return axios.patch(URLS.updatePolicies + policy.id + '/', policy);
};
export const saveDocuments = docs => {
  const formData = new FormData();
  formData.append('commercial_invoice', docs.commercial_invoice);
  // formData.append('idf', docs.idf);
  // formData.append('packing_list', docs.packing_list);
  // formData.append('bill_of_lading', docs.bill_of_lading);
  // formData.append('pvcoc', docs.pvcoc);
  formData.append('quote', docs.quote);
  return axios.post(URLS.documents, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

/**
 *
 * CERTIFICATE SERVICES
 */
export const printCertificate = quote => {
  return axios.get(URLS.printCert + quote);
};

export const emailCertificate = (quote, receivers) => {
  return axios.post(URLS.printCert + quote.id + '/', {
    receivers
  });
};

/**
 *
 * INSURERS & AGENTS
 *
 */
export const getInsurers = () => {
  return axios.get(URLS.insurers);
};

export const getInsurersPremium = () => {
  return axios.get(URLS.insurersbypremiums);
};

export const getAgents = () => {
  return axios.get(URLS.agents);
};

export const createAgent = agent => {
  return axios.post(URLS.agents + '/', agent);
};

export const updateAgent = agent => {
  return axios.put(URLS.agents + '/' + agent.id + '/');
};

export const getCorporateUsers = () => {
  return axios.get(URLS.corporates);
};

export const createCorporateUser = user => {
  return axios.post(URLS.corporate_user, user, {});
};

export const getCompanies = insurer => {
  return axios.get(URLS.companies, {
    params: {
      insurer
    }
  });
};

export const createInsurer = insurer => {
  const formData = new FormData();

  formData.append('company_logo', insurer.company_logo);
  formData.append('company_name', insurer.company_name);
  formData.append('company_code', insurer.company_code);
  formData.append('company_tin', insurer.company_tin);
  formData.append('postal_address', insurer.postal_address);
  formData.append('physical_address', insurer.physical_address);
  formData.append('phone', insurer.phone);
  formData.append('email', insurer.email);
  formData.append('policy_document', insurer.policy_document);
  formData.append('authorized_signature', insurer.authorized_signature);

  return axios.post(URLS.insurers, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const updateInsurer = insurer => {
  const formData = buildFormData(insurer);

  return axios.patch(URLS.insurers + insurer.id + '/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

/**
 *
 * USER MANAGEMENT & PERMISSIONS
 *
 */
export const createUser = user => {
  return axios.post(URLS.register, user);
};

export const createUserAdmin = user => {
  return axios.post(URLS.user_admin, user);
};

export const updateUser = user => {
  const formData = new FormData();

  formData.append('company', user.company);
  formData.append('company_name', user.company_name);
  formData.append('branch_name', user.branch_name);
  formData.append('insurer_admin_role', user.insurer_admin_role);
  //formData.append('insurer_branch', user.insurer_branch);
  formData.append('user.id', user.user.id);
  formData.append('user.date_joined', user.user.date_joined);
  formData.append('user.email', user.user.email);
  formData.append('user.first_name', user.user.first_name);
  formData.append('user.is_active', user.user.is_active);
  formData.append('user.is_admin', user.user.is_admin);
  formData.append('user.is_superuser', user.user.is_superuser);
  //formData.append('user.last_login', user.user.last_login);
  formData.append('user.last_name', user.user.last_name);
  formData.append('user.other_names', user.user.other_names);
  formData.append('user.phone', user.user.phone);
  //formData.append('user.photo', user.user.photo);
  formData.append('user.postal_address', user.user.postal_address);
  formData.append('user.username', user.user.username);
  formData.append('user.user_permissions', user.user.user_permissions);

  return axios.put(URLS.insurerAdmins + user.user.id + '/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getUserPermission = () => {
  return axios.get(URLS.user_permissions);
};

/**
 *
 * LIMITS AND DISCOUNTS
 *
 */
export const getVesselLimits = insurer => {
  return axios.get(URLS.vesselLimits, {
    params: {
      insurer
    }
  });
};

export const addVesselLimits = limit => {
  return axios.post(URLS.vesselLimits, limit);
};

export const getConsignmentLimits = insurer => {
  return axios.get(URLS.consignmentLimits, {
    params: {
      insurer
    }
  });
};

export const addConsignmentLimits = limit => {
  return axios.post(URLS.consignmentLimits, limit);
};

export const getDiscounts = () => {
  return axios.get(URLS.discounts);
};

export const createDiscount = discount => {
  return axios.post(URLS.discounts, discount);
};

export const applyDiscount = discount => {
  return axios.put(URLS.apply_discount + discount.id + '/', discount);
};

export const updateDiscount = discount => {
  return axios.put(URLS.discounts + '/' + discount.id + '/');
};

/**
 *
 * BROKERS, AGENCIES & PARTNERSHIPS
 *
 */
export const getBrokers = filter => {
  return axios.get(URLS.brokers, {
    params: {
      ...filter
    }
  });
};

export const getIntermediaries = () => {
  return axios.get(URLS.brokers);
};

export const getAgencies = () => {
  return axios.get(URLS.agencies);
};

export const getBankAgencies = () => {
  return axios.get(URLS.bank_agencies);
};

export const getBrokerAgencies = () => {
  return axios.get(URLS.brokers_agencies);
};

export const getBrokerAdmins = () => {
  return axios.get(URLS.broker_admins);
};

export const createBroker = broker => {
  return axios.post(URLS.brokers, broker);
};

export const createBrokerPartnership = broker => {
  return axios.post(URLS.brokers_agencies, broker);
};

export const updateBroker = broker => {
  return axios.patch(URLS.brokers + broker.id + '/', broker);
};

export const createAdmin = admin => {
  return axios.post(URLS.broker_admins, admin);
};

export const getPartners = params => {
  return axios.get(URLS.partners, {
    params: {
      ...params
    }
  });
};
/**
 *
 * CLEARING AGENTS
 *
 */
export const getClearingAgents = () => {
  return axios.get(URLS.clearing_agents);
};

export const createClearingAgent = clearing_agent => {
  return axios.post(URLS.create_clearingagents, clearing_agent);
};

export const updateClearingAgent = clearing_agent => {
  return axios.put(
    URLS.open_covers + '/' + clearing_agent.id + '/',
    clearing_agent
  );
};

/**
 *
 * BRANCHES
 *
 */
export const getBranches = insurer => {
  return axios.get(URLS.branches, {
    params: {
      insurer
    }
  });
};

export const createBranch = branch => {
  return axios.post(URLS.branches, branch);
};

export const updateBranch = branch => {
  const formData = buildFormData(branch);
  return axios.patch(URLS.branches + branch.id + '/', formData);
};

/**
 *
 * OPEN COVERS
 *
 */
export const getOpenCovers = filter => {
  return axios.get(URLS.open_covers, {
    params: {
      is_active: 'False',
      ...filter
    }
  });
};

export const createCover = cover => {
  return axios.post(URLS.open_covers, cover);
};

export const createCompany = company => {
  return axios.post(URLS.companies, company);
};

export const editCover = cover => {
  const formData = buildFormData(cover);
  return axios.patch(URLS.open_covers + cover.id + '/', formData);
};

export const editCompany = company => {
  const formData = buildFormData(company);
  return axios.patch(URLS.companies + company.id + '/', formData);
};

export const editCorporateUser = corporate => {
  return axios.patch(URLS.corporates + corporate.user.id + '/', corporate);
};

/**
 *
 * REGIONS
 *
 */
export const getRegions = insurer => {
  return axios.get(URLS.regions, {
    params: {
      insurer
    }
  });
};

export const createRegion = region => {
  return axios.post(URLS.regions, region);
};

export const updateRegion = region => {
  return axios.patch(URLS.regions + region.id + '/', region);
};

export const getCurrencies = () => {
  return axios.get(URLS.currency);
};
/**
 *
 * PAYMENTS
 *
 */
export const getPayments = filter => {
  return axios.get(URLS.payments, {
    params: filter
  });
};

export const sendToSelcom = payment => {
  return axios.post(URLS.selcomDemoPayment, payment);
};

/**
 *
 * POLICIES, CLAIMS & PENDING QUOTES
 *
 */
export const getPolicies = filter => {
  return axios.get(URLS.policies, {
    params: filter
  });
};

export const getQuotes = filter => {
  return axios.get(URLS.quotes, {
    params: filter
  });
};

export const getQuoteGoods = quote_id => {
  return axios.get(URLS.pending_goods, {
    params: {
      quote: quote_id
    }
  });
};

export const getPendingQuotes = () => {
  return axios.get(URLS.policyFilterView, {
    params: {
      is_complete: false
    }
  });
};

export const getFilteredPolicies = filter => {
  return axios.get(URLS.policyFilterView, {
    params: {
      ...filter,
      is_complete: 'True'
    }
  });
};
export const getPoliciesExcel = date_range => {
  return axios.get(URLS.policyFilterView, {
    params: {
      ...date_range
    }
  });
};
export const getClaims = () => {
  return axios.get(URLS.claims_list);
};

export const fileClaim = claim => {
  const formData = new FormData();

  formData.append('insurer', claim.insurer);
  formData.append('policy_number', claim.policy_number);
  formData.append('claim_type', claim.claim_type);
  formData.append('Place_of_Loss', claim.place_of_loss);
  formData.append('Date_of_Loss', claim.date_of_loss);
  formData.append('currency', JSON.stringify(claim.currency));
  formData.append('claim_amount', claim.claim_amount);
  formData.append('packing_list', claim.packing_list);
  formData.append('bill_of_ladding', claim.bill_of_ladding);
  formData.append('invoice', claim.invoice);
  formData.append('claim_status', claim.claim_status);

  return axios.post(URLS.fileClaim, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getCredits = () => {
  return axios.get(URLS.credit_management);
};

export const uploadPolicies = policies => {
  return axios.post(URLS.uploadPolicies, policies);
};

export const listUploadedPolicies = () => {
  return axios.get(URLS.uploadPolicies);
};

export const verifyPolicy = policy_number => {
  return axios.get(URLS.verifyPolicy, {
    params: {
      policy_number
    }
  });
};

export const publicPolicyVerification = policy => {
  return axios.post(URLS.publicPolicyVerification, policy);
};

export const intermediaryDetailView = intermediary => {
  return axios.get(URLS.intermediary_detail_view + intermediary + '/');
};
/**
 *
 * FLAGGING
 *
 */
export const getFlaggedCountries = () => {
  return axios.get(URLS.flagged_country);
};
export const getFlaggedPorts = () => {
  return axios.get(URLS.flagged_port);
};

export const createCountryFlag = countryFlag => {
  return axios.post(URLS.flagged_country, countryFlag);
};
export const createPortsFlag = portsFlag => {
  return axios.post(URLS.flagged_port, portsFlag);
};

export const updateCountryFlag = countryFlag => {
  return axios.put(URLS.flagged_country + '/' + countryFlag.id);
};
export const updatePortFlag = portFlag => {
  return axios.put(URLS.flagged_port + '/' + portFlag.id);
};

/**
 *
 * DASHBOARD
 *
 */
export const getReports = (filter = {}) => {
  return axios.get(URLS.reports, {
    params: filter
  });
};

export const fetchDashboardInfo = () => {
  return axios.get(URLS.dashboard);
};

export const getRevenue = () => {
  return axios.get(URLS.revenueSummary);
};

export const getPremiumsByPurchaseType = insurer => {
  return axios.get(URLS.premiumByPurchaseType + '?insurer=' + insurer);
};

export const getPolicyCountByPurchaseType = insurer => {
  return axios.get(URLS.policyCountByPurchaseType + '?insurer=' + insurer);
};

export const getPremiumTotals = insurer => {
  return axios.get(URLS.premiumSummary + '?insurer=' + insurer);
};

export const getMonthlyPolicyCount = () => {
  return axios.get(URLS.monthlyPolicyCount + startOfWeek + '/' + today + '/');
};

export const getCommissionsSummary = () => {
  return axios.get(URLS.commisionsSummary);
};

export const getPolicyCountSummary = () => {
  return axios.get(URLS.policyCount);
};

export const getWeeklySummary = () => {
  return axios.get(URLS.weeklySummary + startOfWeek + '/' + today + '/');
};

export const getPolicyCommissions = () => {
  return axios.get(URLS.policyCommissions);
};

export const getPoliciesSummaryCount = () => {
  return axios.get(URLS.policies_claim_report);
};

/* TODO: URL Confirmations and proper renaming */
export const getPremiumSummary = () => {
  return axios.get(URLS.premiumSummary);
};

export const getCountSummary = () => {
  return axios.get(URLS.count_summary);
};

export const getMonthlySummary = () => {
  return axios.get(URLS.monthly_summary, {
    params: {
      start_date: '2017-09-09',
      end_date: '2017-12-31'
    }
  });
};

export const getPolicyClaimsCount = () => {
  return axios.get(URLS.policyClaimsCount);
};
/**
 *
 * REPORTS
 *
 */
export const getMCIReports = (filter, date_range) => {
  return axios.get(URLS.mci_reports, {
    params: {
      ...filter,
      ...date_range
    }
  });
};

export const getPolicyReports = (filter, date_range) => {
  return axios.get(URLS.policy_reports, {
    params: {
      ...filter,
      ...date_range
    }
  });
};

export const getGoodsReports = date_range => {
  return axios.get(URLS.mci_reports, {
    params: {
      type: 'sections',
      ...date_range
    }
  });
};

export const getRevenueReports = date_range => {
  return axios.get(URLS.mci_reports, {
    params: {
      type: 'daily',
      ...date_range
    }
  });
};

export const getSalesReports = (filter, date_range) => {
  return axios.get(URLS.sales, {
    params: {
      ...filter,
      ...date_range
    }
  });
};

export const getMapReports = () => {
  return axios.get(URLS.mapReports);
};

export const getMapGeoJSON = () => {
  axios.defaults.baseURL = '/';
  return axios.get(URLS.mapGeoJSON);
};



// WEBPACK FOOTER //
// ./src/utils/apiService.js